import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'OD',
    name: 'Dreimaltoter Prophet',
    id: 'ThriceDeadProphet',
    health: 40,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'OD',
    name: 'Traum-Händler',
    id: 'Wraithmonger',
    health: 70,
    difficulty: 6,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
